// source: friendemic/api/response/tags.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var friendemic_friendly_friendly_pb = require('../../../friendemic/friendly/friendly_pb.js');
goog.object.extend(proto, friendemic_friendly_friendly_pb);
goog.exportSymbol('proto.friendemic.api.response.Tag', null, global);
/**
 * @enum {number}
 */
proto.friendemic.api.response.Tag = {
  UNKNOWN: 0,
  SPANISH: 1,
  FRENCH: 2,
  FLAGGED_FOR_MANAGER: 30,
  FLAGGED_FOR_DISPUTE: 40,
  OVER_LIMIT: 50,
  NO_RESPONSE: 51,
  INTERNAL_APPROVAL_NEEDED: 52,
  AWAITING_CLIENT_INPUT: 53,
  SERIOUS: 54,
  MIXED_REVIEW: 55,
  FAILURE_PROFILE_TURNED_OFF: 60,
  FAILURE_NO_API_ACCESS: 61
};

goog.object.extend(exports, proto.friendemic.api.response);
